import { ReactNode } from 'react';

export enum ProductsView {
  SALES = 'sales',
  UNITS = 'units',
}

export enum ProductsInterval {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
}

export type TableCellType = 'primary' | 'secondary';

export interface TableCell {
  content?: ReactNode;
  type?: TableCellType;
  productChartKeyID?: string;
}

export interface ProductsTableData {
  headers: TableCell[];
  rows: TableCell[][];
}

export interface SingleProductDataResponse {
  fields: string[];
  data: {
    date: string;
    [key: string]: string;
  }[];
}

// New: Tab for the product report (Revenue/Units/COGS)
export enum ProductsTab {
  REVENUE = 'Revenue',
  UNITS = 'Units',
  COGS = 'COGS',
}

export interface ProductBreakdown {
  sold_as: string;
  sold_as_name: string;
  revenue: number[];
  pack_size?: number;
  units: number[];
  total_revenue?: number;
  total_units?: number;
}

// New: Grouping mode
export type ProductsGroupBy = 'category' | 'region';

// New: Product Report response types
export interface ProductReportProduct {
  sku: string;
  name: string;
  category: string;
  channel: string;
  shipping_country?: string;
  cost_per_unit: number;
  inventory_on_hand?: number;
  inventory_incoming?: number;
  revenue: number[];
  units: number[];
  yoy_revenue?: number[];
  yoy_units?: number[];
  total_revenue?: number;
  total_units?: number;
  breakdown?: ProductBreakdown[];
}

// New: Compare mode range metadata
export interface CompareRange {
  from: string;
  to: string;
}

export interface ProductReportData {
  periods: string[];
  yoy_periods?: string[];
  interval: string;
  products: ProductReportProduct[];
  compare_mode?: boolean;
  compare_range?: {
    range_a: CompareRange;
    range_b: CompareRange;
  };
}
